<template>
  <div
    v-show="content"
    :class="$b()"
  >
    <div
      ref="tooltip"
      :class="$b('icon')"
    >
      <span :class="$b('text')">?</span>
    </div>
  </div>
</template>

<script>
import tippy, { inlinePositioning } from 'tippy.js'
import 'tippy.js/dist/tippy.css'

export default {
  name: 'ToolTip',
  props: {
    content: {
      type: String,
      default: '',
    },
    arrowPosition: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right'].includes(value)
      },
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false,
      instance: {},
    }
  },
  watch: {
    content(newContent) {
      if (newContent) this.instance.setContent(newContent)
    },
    show(value) {
      console.log('Show value changed')

      if (value) {
        this.instance.show()
      }
    }
  },
  mounted() {
    const elem = this.$refs.tooltip
    const updateActive = (state) => {
      this.isActive = state
    }

    this.instance = tippy(elem, {
      content: this.content,
      allowHTML: true,
      inlinePositioning: true,
      offset: this.arrowPosition === 'left' ? [-20, 30] : [20, 30],
      maxWidth: 370,
      trigger: 'click',
      placement: this.arrowPosition === 'left' ? 'top-start' : 'top-end',
      plugins: [inlinePositioning],
      onShow() {
        updateActive(true)
      },
      onHide() {
        updateActive(false)
      },
    })
  },
}
</script>

<style lang="postcss">
.ToolTip {
  @apply inline-flex;
  margin-left: 6px;
}

.ToolTip__icon {
  @apply rounded-full bg-gradient
    aspect-square
    text-white
    text-xxs
    font-bold
    flex items-center justify-center
    leading-none
    cursor-pointer
    h-4 w-4;
  transition: background-color 0.2s ease;

  &:focus {
    @apply bg-purple;
  }

  &:hover {
    @media (pointer: fine) {
      @apply bg-purple;
    }
  }
}

.ToolTip__text {
  @apply text-white font-bold leading-none;

  font-size: 12px;
}

.tippy-box {
  @apply bg-grey-light text-off-black drop-shadow-md
    cursor-pointer;

  &::before {
    @apply block absolute
      text-off-black leading-none text-sm
      mb-0
      top-0 right-0
      !pointer-events-auto;
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'%3E%3Cpath d='M17.1939 1L0.955078 17' stroke-width='2' stroke='%231A1A1A' stroke-linecap='square' stroke-linejoin='round'/%3E%3Cpath d='M0.955078 1L17.1939 17' stroke-width='2' stroke='%231A1A1A' stroke-linecap='square' stroke-linejoin='round'/%3E%3C/svg%3E");
    width: 26px;
    height: 26px;
    padding: 8px;
  }
}

.tippy-content {
  @apply p-xs lg:p-sm;
}

.tippy-arrow {
  @apply text-grey-light;

  &::before {
    transform: scale(1.5, 2);
  }
}
</style>
